// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"9e8f456e","155":"a20c92c5","168":"fc3f170c","193":"e434ad4a","236":"a94a5726","308":"078738f9","442":"1e9e5043","453":"2e0fe2cf","665":"63fa3c56","696":"cf4c8fb4","703":"b776f0d5","718":"79dfbf27","796":"a9b7f931","868":"cb5d75aa","932":"ceb8700e","994":"4ed32699"}[chunkId] + ".chunk.js";
};